import React from "react";
import {Box, Tooltip} from "@mui/material";

const PLATFORM_META = {
    TELEGRAM: {
        label: "Telegram",
        color: "#229ED9",
        iconUrl: "/icons/telegram.svg",
    },
    MAX: {
        label: "MAX",
        color: "#7B2CF6",
        iconUrl: "/icons/max.svg",
    },
};

const PlatformBadge = ({platform, size = "small", withLabel = false, sx = {}}) => {
    const meta = PLATFORM_META[platform];
    if (!meta) return null;
    const {iconUrl, color, label} = meta;
    const iconSize = size === "medium" ? 18 : 14;

    const content = (
        <Box
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                color,
                ...sx,
            }}
        >
            <Box
                component="img"
                src={iconUrl}
                alt={label}
                sx={{
                    width: iconSize,
                    height: iconSize,
                    display: "block",
                    objectFit: "contain",
                }}
            />
            {withLabel && (
                <Box component="span" sx={{fontSize: 12, color}}>
                    {label}
                </Box>
            )}
        </Box>
    );

    return withLabel ? content : <Tooltip title={label}>{content}</Tooltip>;
};

export default PlatformBadge;
